import { mapActions, mapState } from 'vuex'

export default {
  props: {
    match: Object,
    team: Object,
    editMode: Boolean,
    title: String,
    bold: Boolean
  },
  data () {
    return {
      showEdit: false,
      isLoading: false,
      form: {
        score1: (this.match.score1 || '').toString(),
        score2: (this.match.score2 || '').toString()
      }
    }
  },
  computed: {
    ...mapState(['groups', 'teams', 'user']),
    group () {
      return this.groups[this.match.group - 1]
    },
    team1 () {
      return this.match.team1 ? this.teams[this.match.team1] : null
    },
    team2 () {
      return this.match.team2 ? this.teams[this.match.team2] : null
    },
    resultText () {
      if (!this.team || !this.match.score1 || !this.match.score2) {
        return this.match.field ? `Boisko nr ${this.match.field}` : ''
      }
      if (this.match.score1 === this.match.score2) return 'Remis'
      if (this.match.score1 > this.match.score2) {
        return this.team.id === this.match.team1 ? 'Zwycięstwo' : 'Porażka'
      }
      return this.team.id === this.match.team2 ? 'Zwycięstwo' : 'Porażka'
    },
    matchTitle () {
      if (!this.match.kind) return this.match.title
      switch (this.match.kind[0]) {
        case 'C':
          return this.$t('match_title_cross', [this.match.kind])
        case 'E':
          return this.$t('match_title_extra', [this.match.kind])
        case 'Q':
          return this.$t('match_title_quarter', [this.match.kind])
        case 'S':
          return this.$t('match_title_semi', [this.match.kind])
        case 'F':
          // eslint-disable-next-line no-case-declarations
          const place = parseInt(this.match.kind[1], 10)
          if (place) return this.$t('match_title_final', [2 * place - 1])
      }
      return this.match.kind
    },
    team1Description () {
      return this.teamDescription(this.match.team1Description)
    },
    team2Description () {
      return this.teamDescription(this.match.team2Description)
    }
  },
  methods: {
    ...mapActions(['patchMatch']),
    matchClicked () {
      if (!this.user.isAdmin) return
      this.showEdit = true
    },
    saveMatch () {
      this.showEdit = false
      this.isLoading = true
      this.patchMatch({ matchId: this.match.id, data: this.form })
        .then(() => { this.isLoading = false })
    },
    teamDescription (teamDescription) {
      if (!teamDescription) return
      switch (teamDescription[0]) {
        case 'A':
        case 'B':
        case 'C':
        case 'D':
          return this.$t('match_team_group', [teamDescription[0], teamDescription[1]])
        case 'L':
          return this.$t('match_team_looser', [teamDescription.substring(1)])
        case 'W':
          return this.$t('match_team_winner', [teamDescription.substring(1)])
      }
      return teamDescription
    }
  }
}
